<template>
  <div class="refund-request">
    <div class="ly-card search-content">
      <div class="btn-group">
        <div class="inline-block">
          <span>操作状态</span>
          <el-select
            class="p-l-5 p-r-5"
            style="width:130px;margin-right:15px;"
            v-model="searchFormData.refund_handle_status"
            clearable
            placeholder="请选择状态"
          >
            <el-option label="未操作" :value="0"> </el-option>
            <el-option label="已同意" :value="1"> </el-option>
            <el-option label="已拒绝" :value="2"> </el-option>
          </el-select>
        </div>
        <div class="inline-block">
          <span>申请时间</span>
          <el-select
            class="p-l-5 p-r-5"
            style="width:120px"
            v-model="searchFormData.sorted_type"
            placeholder="正序"
          >
            <el-option label="正序" value="asc"> </el-option>
            <el-option label="倒序" value="desc"> </el-option>
          </el-select>
        </div>
      </div>
      <div class="search-group">
        <el-input
          placeholder="预约号/学员姓名/证件号码"
          clearable
          style="width:210px"
          v-model.trim="searchFormData.query"
          @keydown.native.enter="() => search()"
        />
        <el-button type="primary" size="medium" @click="() => search()">查询</el-button>
      </div>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      class="ly-card"
      ref="lyTable"
    >
      <template v-slot:sign_up_fee_real_fee="row">
        {{ row.real_fee }}/{{ row.sign_up_fee }}
      </template>
      <template v-slot:action="row">
        <el-button type='primary'  size="mini" v-if="row.refund_handle_status===0" @click.native="showDialog(row)">待处理</el-button>
        <el-button type='info' disabled  size="mini" v-if="row.refund_handle_status===1">已同意</el-button>
        <el-button type='info' disabled  size="mini" v-if="row.refund_handle_status===2">已拒绝</el-button>
      </template>
    </ly-table>
    <el-dialog
      title="操作申请"
      :visible.sync="dialogVisible"
      @close="applyClose"
      width="450px"
      class="register-contact-form refund-dialog"
      center
    >
    <p>是否同意退款申请？</p>
    <span slot="footer" class="dialog-footer">
    <el-button @click="applyRefund(2)">拒绝</el-button>
    <el-button type="primary" @click="applyRefund(1)">同意</el-button>
  </span>
  </el-dialog>
  </div>
</template>

<script>
import {
  Dialog,
  Input,
  Select,
  Option
} from 'element-ui';
import LyTable from '@/components/LyTable';
import { refundRequestTable } from '@/utils/tableHeader';
import { finance } from '@/api';


export default {
  name: 'RefundRequest',
  components: {
    LyTable,
    ElInput: Input,
    ElDialog: Dialog,
    ElSelect: Select,
    ElOption: Option
  },
  data() {
    return {
      searchFormData: {
        query: '',
        refund_handle_status: '',
        sorted_type: 'asc'
      },
      dialogVisible: false,
      tableHeader: refundRequestTable,
      getTableData: finance.refundRequestList,
      applyId: ''
    };
  },
  mounted() {
    this.search();
    finance.getPayType().then(res => {
      if (res) {
        refundRequestTable[refundRequestTable.length - 4].headerSlot.select = res.data;
        refundRequestTable[refundRequestTable.length - 5].headerSlot.select = [
          {
            label: '已缴费',
            value: 4
          },
          {
            label: '已申请退款',
            value: 7
          },
          {
            label: '已退费',
            value: 8
          },
          {
            label: '已拒绝',
            value: 9
          },
          {
            label: '后台退款',
            value: 15
          },
          {
            label: '银联退款中',
            value: 16
          }
        ];
        this.tableHeader = refundRequestTable;
      }
    });
  },
  methods: {
    search(data) {
      this.searchFormData = { ...this.searchFormData, ...data };
      this.$refs.lyTable.setData();
    },
    showDialog(item) {
      this.dialogVisible = true;
      this.applyId = item.id;
    },
    applyRefund(type) {
      this.dialogVisible = false;
      finance.refundRequest({
        id: this.applyId,
        params: {
          refund_handle_status: type
        }
      })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '操作成功');
            this.search();
          }
        });
    },
    applyClose() {
      this.dialogVisible = false;
      this.applyId = '';
    }
  }
};
</script>
<style lang="less">
.refund-request{
  .search-content {
    display: flex;
    justify-content: space-between;
    .search-group .el-input {
      width: 150px;
      margin-right: 20px;
    }
  }
}
</style>
